import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_WholeHealthWellnessSurvey = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_WholeHealthWellnessSurvey' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>Apex Family Healthcare Whole Health and Wellness Survey</h3></center></p>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>1. Medication Management: </span></td>
                        <td className='w-150'><span className='eleHeader'>Comment (Y/N) </span></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are you adhering to your prescribed medications as directed by your current provider at Apex?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtMedicationManagement_1' name='txtMedicationManagement_1' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Do you know the names of the medications you are taking and what they are prescribed for?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtMedicationManagement_2' name='txtMedicationManagement_2' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are you aware of any potential side effects or adverse reactions associated with your medications?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtMedicationManagement_3' name='txtMedicationManagement_3' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are you benefiting from prescribed medications from Apex providers?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtMedicationManagement_4' name='txtMedicationManagement_4' className='add-only' /></center>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>2. Physical Health: </span></td>
                        <td className='w-150'><span className='eleHeader'>Comment (Y/N) </span></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are you attending regular health assessments to monitor your physical well-being? How recently
                            have you seen your medical providers? Are you able to make and get to your appointments easily?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtPhysicalHealth_1' name='txtPhysicalHealth_1' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are you up to date with vaccinations, screenings, and other preventive care measures? Do you need
                            any help getting your prescriptions filled and taking your medications?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtPhysicalHealth_2' name='txtPhysicalHealth_2' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are you making informed choices about your nutrition and engaging in regular exercise to maintain
                            your physical health?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtPhysicalHealth_3' name='txtPhysicalHealth_3' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Have you taken necessary safety measures in your environment to prevent accidents and injuries?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtPhysicalHealth_4' name='txtPhysicalHealth_4' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are you currently experiencing any symptoms or disabilities? Do you have any illnesses other than
                            mental health concerns? How recently have you seen your medical providers? Are you able to make</td>
                        <td className='w-150'>
                            <center><input type='text' id='txtPhysicalHealth_5' name='txtPhysicalHealth_5' className='add-only' /></center>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>3. Mental Health and Emotional Well-being: </span></td>
                        <td className='w-150'><span className='eleHeader'>Comment (Y/N) </span></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            When was your last therapy, paraprofessional, doctor's visit and how did you feel following the
                            session?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtMentalHealth_1' name='txtMentalHealth_1' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            How many therapy sessions have you attended since your last visit?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtMentalHealth_2' name='txtMentalHealth_2' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Do you feel that the frequency of therapy sessions is sufficient to address your needs?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtMentalHealth_3' name='txtMentalHealth_3' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            How have you been feeling emotionally since your last therapy visit?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtMentalHealth_4' name='txtMentalHealth_4' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are there any specific concerns or challenges you would like to discuss with your therapist?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtMentalHealth_5' name='txtMentalHealth_5' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Have you noticed any changes in your mood, thoughts, or behaviors that you would like to address?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtMentalHealth_6' name='txtMentalHealth_6' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are you utilizing coping strategies learned in therapy to manage stress and emotional difficulties
                            effectively?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtMentalHealth_7' name='txtMentalHealth_7' className='add-only' /></center>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>4. Treatment Strategies: </span></td>
                        <td className='w-150'><span className='eleHeader'>Comment (Y/N) </span></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are there any treatment strategies or interventions discussed in therapy that you feel are no longer
                            effective or need adjustment?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtTreatmentStrategies_1' name='txtTreatmentStrategies_1' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are there any new treatment approaches or techniques you would like to explore with your therapist?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtTreatmentStrategies_2' name='txtTreatmentStrategies_2' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Do you feel that the frequency of therapy sessions is sufficient to address your needs?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtTreatmentStrategies_3' name='txtTreatmentStrategies_3' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Have you and your therapist discussed updating or modifying your treatment plan to better suit your
                            current needs and goals?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtTreatmentStrategies_4' name='txtTreatmentStrategies_4' className='add-only' /></center>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>5. Case Management: </span></td>
                        <td className='w-150'><span className='eleHeader'>Comment (Y/N) </span></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Presenting Problem(s)/Immediate Needs
                            <span className='small'>(Do you or your family members need help with any urgent or pressing problem right now?)</span></td>
                        <td className='w-150'>
                            <center><input type='text' id='txtCaseManagement_1' name='txtCaseManagement_1' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Other Case Management Providers
                            <span className='small'>(What other agencies are you working with? What services do they
                                provide you with? Are you working with a case manager or receiving case management anywhere
                                else? Where, and with whom? Are these services meeting your needs?)</span>
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtCaseManagement_2' name='txtCaseManagement_2' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Fluency in English and Ease in Navigating Care Systems
                            <span className='small'>(Do you have any difficulty understanding
                                English? Filling out forms in English? Do you find it easier to talk to your doctor with someone
                                translating for you? Do you have any trouble making your own appointments, understanding medical
                                instructions, getting what you need from a medical or social service agency?)</span>
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtCaseManagement_3' name='txtCaseManagement_3' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Housing
                            <span className='small'>(Do you have any problems with your current housing? Is your housing safe and stable? Is
                                your housing in good repair, with adequate furniture and working appliances? Do you have a working
                                phone? Do you already have or need assistance paying rent?)</span>
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtCaseManagement_4' name='txtCaseManagement_4' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            How is your diet lately? Do you have a regular source of healthy food? Are you maintaining your
                            weight? Do you need help obtaining groceries or meals? Can you get transportation from your home to
                            your appointments, grocery store, easily?

                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtCaseManagement_5' name='txtCaseManagement_5' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Do you have enough clothing to keep you comfortable and protected?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtCaseManagement_6' name='txtCaseManagement_6' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Do you have a steady source of income right now? Does your income meet your basic expenses? Any
                            serious outstanding bills? Do you need any help applying for or keeping your benefits?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtCaseManagement_7' name='txtCaseManagement_7' className='add-only' /></center>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>6. Apex Client-Centered Approach: </span></td>
                        <td className='w-150'><span className='eleHeader'>Comment (Y/N) </span></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Is your treatment plan tailored to address your specific needs and goals?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtClientCentered_1' name='txtClientCentered_1' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Do you feel supported in all aspects of your well-being, including physical and mental health?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtClientCentered_2' name='txtClientCentered_2' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are Apex services respectful of your background, culture, and personal beliefs?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtClientCentered_3' name='txtClientCentered_3' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Do you experience seamless coordination of care between different healthcare providers and services?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtClientCentered_4' name='txtClientCentered_4' className='add-only' /></center>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>7. Client Experience and Satisfaction: </span></td>
                        <td className='w-150'><span className='eleHeader'>Comment (Y/N) </span></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are your needs, concerns, and feedback effectively communicated to Apex staff?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtClientExperience_1' name='txtClientExperience_1' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Do you feel respected and valued in your interactions with Apex?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtClientExperience_2' name='txtClientExperience_2' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Are you empowered to actively participate in decisions regarding your treatment plan?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtClientExperience_3' name='txtClientExperience_3' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Can you trust that your personal information is treated with strict confidentiality and privacy?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtClientExperience_4' name='txtClientExperience_4' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Is the care you receive regularly assessed for its effectiveness and impact on your well-being?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtClientExperience_5' name='txtClientExperience_5' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Do you feel that Apex staff members are properly trained in providing personalized care and effective
                            communication?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtClientExperience_6' name='txtClientExperience_6' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Do you feel that your interventions and treatments are monitored to ensure long-term effectiveness?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtClientExperience_7' name='txtClientExperience_7' className='add-only' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            Do you believe that Apex is committed to continuously improving services based on your feedback
                            and identified areas for enhancement?
                        </td>
                        <td className='w-150'>
                            <center><input type='text' id='txtClientExperience_8' name='txtClientExperience_8' className='add-only' /></center>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><hr /></p>

                <p className='w-750'>
                    <span className='eleHeader'>Recommendations from Clinic Manager</span>
                    <span className='small'>(Treatment strategies, outside referrals, etc):</span>
                    <textarea name='txtClinicManager' id='txtClinicManager' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Recommendations for Improvements from Client:</span>
                    <textarea name='txtImprovementsClient' id='txtImprovementsClient' className='add-only'></textarea>
                </p>



            </div>
        </form>

    )
}   